module.exports = __webpack_public_path__ + "tldv-1-1ff754ad02aea09fe65e6dadcce1c383.webp";